import React from "react";

interface LoaderContextType {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LoaderContext = React.createContext<LoaderContextType>({
  isLoading: false,
  setIsLoading: () => {},
});
